import { render, staticRenderFns } from "./outrights-widget.vue?vue&type=template&id=6fe685b6&"
import script from "./outrights-widget.vue?vue&type=script&lang=js&"
export * from "./outrights-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsLoader: require('/var/web/bet777.es/components/elements/loader.vue').default,MarketOutright: require('/var/web/bet777.es/components/market/outright.vue').default})
